---
fr:
  overview:
    48hrs: "(48 h)"
    dir:
      asc: "▼"
      desc: "▲"
    effect_overflow_tip: Vérifiez que la production max actuelle est correcte pour cette centrale
    precipitation: Précipitation (prévisions 48 heures)
    sensor_values:
      above_limit: Au-dessus de la limite
      below_limit: Au-dessous de la limite
      within_limits: Dans les limites
    sort:
      current_effect: Production actuelle
      current_income: Revenu
      name: Nom
      precipitation: Précipitation
      rated_power_mw: Capacité maximale
      utilization: Utilisation
    variants:
      advanced: Aperçu avancée
      basic: Aperçu simplifié
